<div fxLayout="column" class="light" [class.divider-left]="sideMode === 'side'" fxFlexFill>

  <div fxLayoutAlign="center center" class="title-basket layout-padd shadowed" [ngStyle.gt-xs]="{'height.px' : 40}"
    [ngStyle.xs]="{'height.px' : 35}">
    <mat-icon *ngIf="sideMode === 'over'" (click)="closeBasket()" class="close-basket-bnt clicked layout-padd-l">
      keyboard_arrow_right</mat-icon>

    <span class="mat-caption weight-basket" *ngIf="currSm &&
      currSm.enable_shipping_cost> 0">{{"basket.weight" | translate}}:
      {{totalWeightPan}}kg</span>

    <mat-icon class="dark-ico">shopping_basket</mat-icon>

  </div>

  <div class="fill-rest scrolled">

    <div fxLayoutGap="10px" class="scrolled fill-rest" id="endPanier" *ngIf="panier$ && panier$.length> 0">

      <div *ngFor="let prod of panier$; let index= index; let last= last;" fxLayout="column" fxLayoutGap="5px"
        class="full-w layout-padd" [class.divider]="!last">

        <div>

          <div fxFlex="15" fxLayoutAlign="start center">


            <mat-select class="full-w" [(ngModel)]="prod.quantity"
              (valueChange)="QtyStockChange($event, prod.quantity)">
              <mat-option [value]="quant" *ngFor="let quant of prod.quantities" (click)="updateQuantPan(index, prod)"
                angulartics2On="click" angularticsAction="updateQuantityFromShoppingCart" angularticsCategory="product">
                {{quant}}

              </mat-option>
            </mat-select>

          </div>

          <div fxLayoutAlign="start center" fxLayoutGap="10px" class="layout-padd-2" fxFlex>
            <img *ngIf="prod.image.length> 0" [src]="prod.image[2]" class="basket-prod-img">
            <img *ngIf="prod.image.length <1" [src]="default_prod" class="basket-prod-img">
            <!-- <span class="mat-subheading-1">{{prod.name | uppercase}}</span> -->
            <span class="mat-subheading-1">{{prod.display_lang.name | uppercase}}</span>
          </div>

          <div fxFlex="30" fxLayoutAlign="end center" fxLayoutGap="10px">

            <del *ngIf="prod.old_total_after_period">
              <span class="mat-caption warn-ico">{{(prod.old_total_after_period *
                prod.quantity) | priceFilter}}</span>
            </del>

            <span class="mat-subheading-1 boldest">{{(prod.price *
              prod.quantity) | priceFilter}}</span>

          </div>

        </div>

        <div *ngIf="prod.details.length> 0">

          <div *ngFor="let sdet of prod.details">

            <div fxLayout="column">

              <div fxLayoutAlign="space-between center">

                <div fxFlex="15" fxLayoutAlign="start center">
                  <span class="mat-subheading-1" *ngIf="sdet.quantity> 1">{{sdet.quantity}}</span>
                </div>

                <div fxFlex fxLayoutAlign="start center">
                  <span class="mat-subheading-1">{{sdet.name | uppercase}}</span>
                </div>

                <div fxFlex="30" fxLayoutAlign="start center" *ngIf="sdet.price>
                  0">
                  <span class="mat-subheading-1">+{{(sdet.price *
                    prod.quantity)| priceFilter}}</span>
                </div>

              </div>

              <div *ngFor="let ssdet of sdet.details">

                <div fxFlex="30" fxLayoutAlign="start center"></div>

                <div fxFlex fxLayoutAlign="start center">
                  <span class="mat-caption">{{ssdet.name | uppercase}}</span>
                </div>

                <div fxFlex="30" fxLayoutAlign="start center" *ngIf="ssdet.price>
                  0">
                  <span class="mat-caption">+{{(ssdet.price * prod.quantity) |
                    priceFilter}}</span>
                </div>

              </div>

            </div>

          </div>

        </div>

        <div *ngIf="prod.comment">
          <span class="mat-caption" style="font-style: italic;">{{prod.comment}}</span>
        </div>

        <div fxLayoutAlign="end" fxLayoutAlign="space-between center">

          <span class="mat-caption warn-ico clicked boldest" (click)="removeProdPan(index, prod)" angulartics2On="click"
            angularticsAction="deleteProduct" angularticsCategory="product">{{"basket.delete"
            | translate}}</span>

          <span class="mat-caption great-ico clicked boldest" *ngIf="prod.product_type> 0 && tools.checkCurrentPage('Product') &&
            (!prod.has_stock ||prod.has_stock&&prod.quantity==1)" (click)="openProdDial(prod, 'update', index)"
            angulartics2On="click" angularticsAction="openUpdateDialog" angularticsCategory="product">{{"basket.update"
            | translate}}</span>

        </div>

      </div>

    </div>

    <!-- Product|Pointofsale Page -->
    <div fxLayout="column" fxLayoutAlign="center center" fxFlexFill *ngIf="panier$ && panier$.length <1 &&
      !tools.checkCurrentPage('Endorder')">

      <img src="assets/img/icons/empty-basket.png" style="height: 50px;">
      <span class="mat-title">{{"basket.empty" | translate}}</span>

    </div>

    <!-- EndOrder Page -->
    <div fxLayoutAlign="center center" fxFlexFill *ngIf="panier$ &&
      panier$.length <1 && tools.checkCurrentPage('Endorder')">

      <button [class.animAlert]="error === 'emptypanier'" mat-raised-button color="primary"
        (click)="tools.goProductPage()" angulartics2On="click" angularticsAction="redirectProductFromShoppingCart"
        angularticsCategory="order">{{"basket.choose-product" | translate}}</button>
    </div>

  </div>

  <!-- Endorder Page -->
  <div class="layout-padd divider-top" *ngIf="tools.checkCurrentPage('Endorder')">

    <!-- Sous total (Shipping cost && Delivery cost)-->
    <div fxLayout="row" fxLayoutAlign="space-between" class="full-w"
      *ngIf="currSm.enable_shipping_cost> 0 || currSm.enable_delivery > 0">
      <span class="mat-subheading-1">{{"basket.sub-total"|translate}}:</span>
      <span class="mat-subheading-1">{{totalPricePan | priceFilter}}</span>
    </div>

    <!-- Shipping cost -->
    <div fxLayout="column" *ngIf="currSm.enable_shipping_cost> 0">

      <!-- Shipping cost -->
      <div fxLayout="row" fxLayoutAlign="space-between" class="full-w">

        <span class="mat-subheading-1" *ngIf="!isRelay">{{"basket.shipping-cost"|translate}}
          {{currAddress ?
          '(' + (currAddress.country_name | capitalize) +
          ')' : '' |
          capitalize}}:</span>

        <span class="mat-subheading-1" *ngIf="isRelay && selectedRelay">{{"basket.shipping-cost"|translate}}
          {{ '(' + selectedRelay.Pays +
          ')'}}:</span>

        <span class="mat-subheading-1 warn-ico" *ngIf="shippingPrice <0">{{"basket.undefined"|translate}}</span>
        <span class="mat-subheading-1" *ngIf="shippingPrice> 0">{{shippingPrice
          | priceFilter}}</span>
        <span class="mat-subheading-1" *ngIf="shippingPrice === 0 &&
          panier$.length === 0">{{0 | priceFilter}}</span>


        <span class="mat-subheading-1 great-ico boldest" *ngIf="shippingPrice
          === 0 && !shippingOffer && !needRelay">{{"basket.free"|translate}}</span>
        <span class="mat-subheading-1 great-ico boldest" *ngIf="shippingPrice
          === 0 && shippingOffer && !needRelay">{{"basket.offer"|translate}}</span>
        <span class="mat-caption warn-ico boldest text-center"
          *ngIf="needRelay">{{"basket.select-relay"|translate}}</span>
      </div>

      <!-- Shipping offer -->
      <div fxLayout="row" *ngIf="shippingOffer && shippingPrice> 0">
        <span class="mat-caption">({{"basket.shipping-cost-offer"| translate}}
          {{shippingOffer | priceFilter}})</span>
      </div>


    </div>

    <!-- Delivery cost -->
    <div fxLayout="row" fxLayoutAlign="space-between" class="full-w" *ngIf="currSm.enable_delivery> 0">

      <span class="mat-subheading-1">{{"basket.shipping-cost"|translate }} {{currAddress ? '(' +
        (currAddress.city_name | capitalize) +
        ')' : ''
        }}:</span>
      <span class="mat-subheading-1 warn-ico" *ngIf="deliveryPrice === null">{{"basket.undefined"|translate}}</span>
      <span class="mat-subheading-1" *ngIf="deliveryPrice> 0">{{deliveryPrice |
        priceFilter}}</span>
      <span class="mat-subheading-1" *ngIf="deliveryPrice === 0">{{"basket.free"|translate }}</span>
    </div>

    <!-- Errors shipping cost -->
    <div fxLayoutAlign="start center" class="warn-ico full-w layout-padd" *ngIf="shippingPrice <0">

      <span class="mat-subheading-1" *ngIf="shippingPrice === -1 &&
        currAddress">{{"basket.weight-to-high"|translate}} <i class="material-icons clicked icon-info"
          angulartics2On="click" angularticsAction="openWeightTableDial" angularticsCategory="order"
          matTooltip="{{'basket.rate-weight-prices'|translate}}" (click)="myDials.openWeightTableDial(currAddress, isRelay,
          selectedRelay)">info</i></span>

      <span class="mat-subheading-1" *ngIf="shippingPrice === -2 &&
        currAddress">{{"basket.country-not-eligible" | translate}} <i class="material-icons clicked icon-info"
          angulartics2On="click" angularticsAction="openWeightTableDial" angularticsCategory="order"
          matTooltip="{{'basket.rate-weight-prices'|translate}}" (click)="myDials.openWeightTableDial(currAddress, isRelay,
          selectedRelay)">info</i></span>

      <span class="mat-subheading-1" *ngIf="!currAddress">{{"basket.need-delivry-address"
        | translate}} <i class="material-icons clicked icon-info" angulartics2On="click"
          angularticsAction="openWeightTableDial" angularticsCategory="order"
          matTooltip="{{'basket.rate-weight-prices'|translate}}" (click)="myDials.openWeightTableDial(currAddress, isRelay,
          selectedRelay)">info</i></span>

    </div>

    <!-- Errors delivry cost -->
    <div fxLayoutAlign="start center" class="warn-ico full-w layout-padd"
      *ngIf="currSm.enable_delivery> 0 && deliveryPrice === null">

      <span class="mat-subheading-1" *ngIf="currAddress">{{"basket.city-not-eligible"
        | translate}} <i class="material-icons clicked icon-info" angulartics2On="click"
          angularticsAction="openEligibleCitiesDial" angularticsCategory="order"
          matTooltip="{{'basket.eligible-cities-list' | translate}}"
          (click)="myDials.openEligibleCitiesDial()">info</i></span>

      <span class="mat-subheading-1" *ngIf="!currAddress">{{"basket.need-delivry-address"
        | translate}} <i class="material-icons clicked icon-info" angulartics2On="click"
          angularticsAction="openEligibleCitiesDial" angularticsCategory="order"
          matTooltip="{{'basket.eligible-cities-list' | translate}}"
          (click)="myDials.openEligibleCitiesDial()">info</i></span>

    </div>

    <!-- All total -->
    <div fxLayout="row" fxLayoutAlign="space-between" class="full-w" style="margin-top: 10px;">
      <span class="mat-title" translate [translateParams]="{count:
        totalQuantPan}">basket.totalprod</span>
      <span class="mat-title boldest">{{allTotal | priceFilter}}</span>
    </div>

  </div>

  <!-- Product|Pointofsale Page -->
  <div class="layout-padd divider-top" *ngIf="!tools.checkCurrentPage('Endorder')">

    <div fxLayout="row" fxLayoutAlign="space-between" class="full-w" *ngIf="currSm">

      <div>

        <div fxLayout="row" fxLayoutGap="5px">

          <div>
            <span class="mat-title" *ngIf="currSm.enable_shipping_cost> 0 ||
              currSm.enable_delivery > 0">{{"basket.total" | translate}}</span>
            <span class="mat-title" translate [translateParams]="{count:
              totalQuantPan}" *ngIf="currSm.enable_shipping_cost <1 &&
              currSm.enable_delivery <1">basket.totalprod</span>
          </div>

          <div>
            <span class="mat-caption" *ngIf="currSm.enable_shipping_cost> 0 ||
              currSm.enable_delivery > 0">({{"basket.exclud-delivry" |
              translate}})</span>
          </div>

        </div>

      </div>

      <div>
        <span class="mat-title boldest">{{totalPricePan | priceFilter}}</span>
      </div>

    </div>

    <div fxLayout="row" fxLayoutAlign="space-between" class="full-w" *ngIf="!currSm">

      <div>
        <span class="mat-title">{{"basket.total" | translate}}</span>

      </div>

      <div>
        <span class="mat-title boldest">{{0 | priceFilter}}</span>
      </div>

    </div>

  </div>

  <!-- Buttons -->
  <div class="layout-padd" style="padding-top: 0;">

    <!-- Product|Pointofsale Page -->
    <div *ngIf="!tools.checkCurrentPage('Endorder')">
   
      <button mat-raised-button color="primary" class="full-w" [disabled]="panier$ && panier$.length === 0"
        (click)="goEndOrder()">
        <span *ngIf="(currSm && !currSm.enable_device_check) || !currSm">{{"basket.payment" | translate}}</span>
        <span *ngIf="currSm && currSm.enable_device_check">{{"button.validate" | translate}}</span>
        
      </button>

      <div *ngIf="currSm && currSm.minimum_order" fxLayoutAlign="end center" class="layout-padd-2 full-w">
        <span class="mat-subheading-1">{{"basket.minimum" | translate}}:
          <strong>{{currSm.minimum_order |
            priceFilter}}</strong></span>
      </div>

    </div>

    <!-- EndOrder Page -->
 
    <button mat-raised-button color="primary" class="full-w" (click)="submitOrder()" [disabled]="!activeButton"
      angulartics2On="click" angularticsAction="openConfirmOrderDialog" angularticsCategory="order"
      *ngIf="tools.checkCurrentPage('Endorder')">{{"basket.finalize-order" |
      translate}}</button>

  </div>

</div>
